export const isMobile = () => {
  const windowWidth = window.innerWidth;
  return windowWidth < 1024;
};
